import {Button} from '@/ui/kit/ButtonLink/Button';
import {ButtonLinkMods, ButtonLinkSize} from '@/ui/kit/ButtonLink/ButtonLink';

export type ErrorButtonProps = {
  buttonText: string;
  className?: string;
  onClick: VoidFunction;
  isDisabled?: boolean;
};

export function ErrorButton({buttonText, isDisabled, className, onClick}: ErrorButtonProps): JSX.Element | null {
  if (!buttonText) return null;
  return (
    <Button
      mod={ButtonLinkMods.ButtonPrimary}
      size={ButtonLinkSize.S}
      isDisabled={isDisabled}
      onClick={onClick}
      className={className}
    >
      {buttonText}
    </Button>
  );
}
